import React from "react";
import {
  createTheme,
  ThemeProvider,
  Typography,
  Container,
  Box,
  Paper,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import aboutUsCars from "./Assets/aboutUsCars.jpg";
import safetyDriver from "./Assets/safetyDriver.png";
import useWindowSize from "./useWindowSize";
import Carousel from "react-multi-carousel";

// Theme setup
const theme = createTheme({
  palette: {
    primary: { main: "#1C2541" },
    secondary: { main: "#38AECC" },
    background: { default: "#F4F4F4" },
  },
});

// Styled image
const StyledImage = styled("img")({
  width: "100%",
  maxWidth: "450px",
  height: "400px",
  borderRadius: "20px",
  objectFit: "cover",
  margin: "0 auto",
  display: "block",
});

// Carousel responsiveness
const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 1 },
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
  tablet: { breakpoint: { max: 1024, min: 768 }, items: 1 },
  mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
};

// Reusable slide component
const AboutSlide = ({ image, title, text }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box px={{ xs: 2, md: 6 }} sx={{ py: "10px" }}>
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="center"
        direction={"row"}
      >
        <Grid item xs={12} md={6}>
          <StyledImage src={image} alt={title} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper
            elevation={4}
            sx={{
              borderRadius: 4,
              p: { xs: 2, sm: 3, md: 4 },
              height: isMobile ? "auto" : "400px",
              maxWidth: "500px",
              width: "100%",
              mx: "auto",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "primary.main",
                fontWeight: "bold",
                mb: 2,
                textAlign: "center",
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              sx={{ textAlign: "justify", color: "#000" }}
            >
              {text}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

// Main component
const About = () => {
  const { t } = useTranslation();
  const size = useWindowSize();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ py: 6 }}>
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            component="h2"
            sx={{ color: "primary.main", textAlign: "center", mb: 4 }}
          >
            {t("about")}
          </Typography>
          {isSmallScreen ? (
            <Typography
              variant="body1"
              sx={{ textAlign: "justify", color: "#000" }}
            >
              {t("about1")}
            </Typography>
          ) : (
            <Carousel
              swipeable
              draggable
              infinite
              autoPlay
              autoPlaySpeed={5000}
              arrows={false}
              responsive={responsive}
            >
              <AboutSlide
                image={aboutUsCars}
                title={t("ourHistory")}
                text={t("about1")}
              />
              <AboutSlide
                image={safetyDriver}
                title={t("promiseFulfilled")}
                text={t("about2")}
              />
            </Carousel>
          )}
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default About;
